export default __webpack_public_path__ + "static/media/storageUnit1-afterD-1440w.aa65de67.avif";